import type { ReactNode } from 'react';
import {
  GOOGLE_ANALYTICS_NAVIGATION_ACTION,
  useSendNavigationClickToGoogleAnalytics
} from '~/tracking/googleAnalytics';

export function TrackNavigationClick({
  label,
  action = GOOGLE_ANALYTICS_NAVIGATION_ACTION.MainNavigation,
  children
}: Readonly<{
  label: string;
  action?: string;
  children: ReactNode;
}>) {
  const sendNavigationClick = useSendNavigationClickToGoogleAnalytics();

  return (
    <span style={{ display: 'contents' }} onClickCapture={() => sendNavigationClick(label, action)}>
      {children}
    </span>
  );
}
